import { Flex, Input, Radio, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { EXPIRATION_TYPE } from './constants'
import './index.scss'

interface IExpiration {
  control: Control<any>
  errors?: FieldErrors<any>
}

const Expirations = (props: IExpiration) => {
  const { t } = useTranslation()
  const { control } = props

  const handleOnchangeInput = (e: any, inputField: any) => {
    let inputValue = e.target.value
    inputValue = inputValue.trim().replace(/\D/g, '')

    const e1: any = e
    e1.target.value = inputValue
    inputField.onChange(e1)
  }

  return (
    <Flex vertical style={{ marginBottom: 16 }}>
      <Typography className='title' style={{ marginBottom: 12 }}>
        {t('UserRoles:expirations')}
      </Typography>

      <Controller
        name='expirations'
        control={control}
        disabled={true}
        render={({ field }) => (
          <Radio.Group
            {...field}
            name='expirations'
            style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}
          >
            <Radio value={EXPIRATION_TYPE.DOES_NOT_EXPIRE} className='radio-wrapper-first'>
              <Typography className='expiration-option'>{t('UserRoles:doesNotExpire')}</Typography>
            </Radio>
            <Radio value={EXPIRATION_TYPE.EXPIRE_X_MINUTES} className='radio-wrapper'>
              <Flex gap={16} align='flex-start'>
                <Typography className='expiration-option'>{t('UserRoles:durationExpiresInMinutes')}</Typography>
                <Flex vertical justify='flex-start' gap={10} style={{ width: '100%' }}>
                  <Controller
                    name='expirationMinutes'
                    control={control}
                    render={({ field: inputField }) => (
                      <Input
                        {...inputField}
                        className='ant-input-view-only'
                        style={{ maxWidth: 376, width: '100%' }}
                        placeholder={t('UserRoles:enterMinutes')}
                        maxLength={10}
                        disabled
                        name='expirationMinutes'
                        onChange={(e) => {
                          handleOnchangeInput(e, inputField)
                        }}
                      />
                    )}
                  />
                </Flex>
              </Flex>
            </Radio>
            <Radio value={EXPIRATION_TYPE.EXPIRE_X_DAYS} className='radio-wrapper'>
              <Flex gap={16} align='flex-start'>
                <Typography className='expiration-option'>{t('UserRoles:durationExpiresInDays')} </Typography>
                <Flex vertical justify='flex-start' gap={10} style={{ width: '100%' }}>
                  <Controller
                    name='expirationDays'
                    control={control}
                    render={({ field: inputField }) => (
                      <Flex align='flex-end'>
                        <Input
                          {...inputField}
                          className='ant-input-view-only'
                          style={{ maxWidth: 376, width: '100%' }}
                          placeholder={t('UserRoles:enterDays')}
                          maxLength={10}
                          disabled
                          name='expirationDays'
                          onChange={(e) => {
                            handleOnchangeInput(e, inputField)
                          }}
                        />
                      </Flex>
                    )}
                  />
                </Flex>
              </Flex>
            </Radio>
          </Radio.Group>
        )}
      />
    </Flex>
  )
}

export default Expirations
